import { render, staticRenderFns } from "./IncidentCard.vue?vue&type=template&id=fcefb7bc&scoped=true"
import script from "./IncidentCard.vue?vue&type=script&lang=js"
export * from "./IncidentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcefb7bc",
  null
  
)

export default component.exports